export default __webpack_public_path__ + "static/media/Claire.fa90be51.jpg";